import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const offerSelector = createSelector(testTargetOffersSelector, offers => offers.showGuestCheckoutForBopisAndSdd || Empty.Object);
const showSelector = createSelector(offerSelector, showGuestCheckoutForBopisAndSdd => !!showGuestCheckoutForBopisAndSdd.show);
const showGuestCheckoutForBopisAndSddAbTestSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showGuestCheckoutForBopisAndSddAbTestSelector };
